import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/data-access';
import { Observable } from 'rxjs';
import { VerificationCodeRequest, RegisterGuestRequest, NotificationBannerReadRequest } from '../../models/request.models';
import { NotificationBannerReadResponse } from '../../models/responses.models';

@Injectable({
  providedIn: 'root',
})
export class PageLayoutApiService {
  constructor(private api: BaseApiService) {}

  sendVerificationRequest(userUid: string, request: VerificationCodeRequest): Observable<number> {
    return this.api.post(`api/users/${userUid}/verify`, request);
  }

  registerGuest(userUid: string, payload: RegisterGuestRequest): Observable<unknown> {
    return this.api.patch(`api/users/${userUid}/register`, payload);
  }

  updateUserNotificationBannerRead(uid: string, request: NotificationBannerReadRequest): Observable<NotificationBannerReadResponse> {
    return this.api.patch(`api/users/${uid}/notification-banner`, request);
  }
}
